module.exports = __webpack_public_path__ + "img/senalando-izqdo.8f78fd2f.png";